import { ElectricalAspectResolverBase } from './electrical-aspect.resolver.base';
import { ElectricalAspectService } from './electrical-aspect.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class ElectricalAspectResolver extends ElectricalAspectResolverBase {

  constructor(protected service: ElectricalAspectService) {
    super(service);
  }
}



